import { CallCollectionsReorderItem } from '~src/app/actions/AppActionTypes';
import { isActionFactory } from '~src/app/actions/isActionFactory';

import { SpaceInfo } from '../state/SpaceInfo';
import { ReorderItemAction } from './ReorderItem';

export interface CallReorderItemAction extends ReorderItemAction {}

// this is the action calling the collections saga.
export function callCollectionsReorder(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): CallReorderItemAction {
  return {
    type: CallCollectionsReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isCallReorderItemAction = isActionFactory<CallReorderItemAction>(CallCollectionsReorderItem);
